import { INSPECTOR_SWITCH } from "../../../constants/inspectorConstants";
import Symbol from "./Symbol";

class Switch extends Symbol {
    constructor({ alias, svgSrc, label, rotable, handles, name}) {
        super("Switch", { alias, svgSrc, label, rotable, handles, name });

        this.attributes = {
            ...this.attributes,
            brand: { isVisible: false, value: null, label: "Marca" },
            model: { isVisible: false, value: null, label: "Modelo" },
            ratedCurrent: { isVisible: false, value: null, label: "Corriente Nominal" },
            interruptingCapacity: { isVisible: false, value: null, label: "Capacidad Interruptiva" },
        };                
    }

    getInspector() {
        return INSPECTOR_SWITCH;
    }
}

export default Switch;
